import { isEmail } from 'validator';

import { validateForUI } from 'common/helpers/jsonValidator';

const customerNotLoggedInSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' },
    notes: { type: 'string' }
  },
  required: ['email'],
  additionalProperties: false
};

const customerLoggedInSchema = {
  type: 'object',
  properties: {
    notes: { type: 'string' }
  },
  additionalProperties: false
};

export const validateCustomerNotLoggedIn = (object) => {
  const errors = validateForUI(
    customerNotLoggedInSchema,
    object,
    customValidateNotLoggedIn(object)
  );
  return errors;
};

export const validateCustomerLoggedIn = (object) => {
  const errors = validateForUI(customerLoggedInSchema, object);
  return errors;
};

const customValidateNotLoggedIn = (email) => {
  const errorArray = [];

  if (email.email && !isEmail(email.email)) {
    const error = { field: `email`, message: 'Invalid Email' };
    errorArray.push(error);
  }
  return errorArray;
};
